import React, { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, FormRow, FileUpload, TagsInput } from '../controls';

const defaultLinks = {
  instagram: '',
  twitter: '',
  facebook: '',
  web: '',
};

function buildDefaultValues(vendor) {
  const values = {
    vendorName: vendor ? vendor.vendorName || '' : '',
    vendorContact: vendor ? vendor.vendorContact || '' : '',
    vendorDescription: vendor ? vendor.vendorDescription || '' : '',
    links: vendor ? vendor.links || defaultLinks : defaultLinks,
    category: null,
    subcategory: null,
  };

  if (vendor?.category) {
    values.category = vendor.category;
  }
  if (vendor?.subcategory) {
    values.subcategory = vendor.subcategory;
  }

  return values;
}

export function VendorForm({
  vendor,
  vendorCategories,
  onFileUpload,
  onFileDelete,
  handleSave,
}) {
  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: buildDefaultValues(vendor),
    mode: 'onSubmit',
  });

  useEffect(() => {
    reset(buildDefaultValues(vendor));
  }, [vendor, reset]);

  const saveVendor = (values) => {
    const { vendorId } = vendor;
    const category = values.category ? values.category : '';
    const subcategory = values.subcategory ? values.subcategory : '';
    const payload = { ...values, category, subcategory, vendorId };

    handleSave(payload);
  };

  const categories = vendorCategories.categories || [];
  const subcategories = vendorCategories.subcategories || [];

  const fileList = [];

  if (vendor?.photoURL) {
    fileList.push({
      uid: '-1',
      name: vendor.vendorPhoto,
      url: vendor.photoURL,
      status: 'done',
    });
  }

  return (
    <form onSubmit={handleSubmit(saveVendor)}>
      <div className="flex">
        <div className="w-3/4 p-4">
          <FormRow label="Vendor Name" error={errors.vendorName?.message}>
            <input
              type="text"
              placeholder="Name"
              {...register('vendorName', {
                required: 'Vendor name is required',
              })}
            />
          </FormRow>
          <FormRow label="Contact">
            <input
              type="text"
              placeholder="Contact"
              {...register('vendorContact')}
            />
          </FormRow>
          <FormRow label="Category" error={errors.category?.message}>
            <Controller
              name="category"
              control={control}
              rules={{ required: 'Category is required' }}
              render={({ field }) => (
                <TagsInput
                  value={field.value}
                  placeholder="Select or enter a category"
                  options={categories}
                  onChange={field.onChange}
                />
              )}
            />
          </FormRow>
          <FormRow label="Subcategory">
            <Controller
              name="subcategory"
              control={control}
              render={({ field }) => (
                <TagsInput
                  value={field.value}
                  placeholder="Select or enter a subcategory"
                  options={subcategories}
                  onChange={field.onChange}
                />
              )}
            />
          </FormRow>
        </div>
        <div className="w-1/4 p-4">
          <FormRow>
            <div className="w-full">
              <FileUpload
                fileList={fileList}
                onFileUpload={onFileUpload}
                onFileDelete={onFileDelete}
              />
            </div>
          </FormRow>
        </div>
      </div>
      <FormRow label="Description">
        <textarea
          placeholder="Vendor Description..."
          {...register('vendorDescription')}
        />
      </FormRow>
      <FormRow label={<FontAwesomeIcon icon={['fas', 'globe']} />}>
        <input type="text" placeholder="Website" {...register('links.web')} />
      </FormRow>
      <FormRow label={<FontAwesomeIcon icon={['fab', 'facebook']} />}>
        <input
          type="text"
          placeholder="Facebook"
          {...register('links.facebook')}
        />
      </FormRow>
      <FormRow label={<FontAwesomeIcon icon={['fab', 'twitter']} />}>
        <input
          type="text"
          placeholder="Twitter"
          {...register('links.twitter')}
        />
      </FormRow>
      <FormRow label={<FontAwesomeIcon icon={['fab', 'instagram']} />}>
        <input
          type="text"
          placeholder="Instagram"
          {...register('links.instagram')}
        />
      </FormRow>
      <Button className="float-right mt-4" mode="dark" type="submit">
        Save Vendor
      </Button>
    </form>
  );
}
